import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cn from 'classnames';
import { SuperEllipse } from '@alfalab/core-components/icon-view/super-ellipse';
import { SystemMessage } from '@alfalab/core-components/system-message';
import styles from './index.module.css';
export const Graphic = memo(({ graphicBottomAddon, graphicTopAddon, image, Icon, iconClassName, iconBackgroundColor, }) => {
    if (image) {
        return (_jsx(SystemMessage.Graphic, { className: styles.component, children: _jsx("img", { className: iconClassName, src: image, width: '100%', alt: '\u0424\u043E\u043D \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u043E\u0433\u043E \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F' }) }));
    }
    if (Icon) {
        return (_jsx(SystemMessage.Graphic, { className: styles.component, children: _jsx(SuperEllipse, { backgroundColor: iconBackgroundColor, className: cn(iconClassName, {
                    [styles.defaultBGColor]: !iconBackgroundColor,
                }), topAddons: graphicTopAddon, bottomAddons: graphicBottomAddon, size: 80, children: _jsx(Icon, {}) }) }));
    }
    return null;
});
Graphic.displayName = 'Graphic';
